/**
 * Static data for forms
 */
export class FormData
{
	static STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN',
		'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
		'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA',
		'WA', 'WV', 'WI', 'WY'];

	/**
	 * Returns the states as an array of objects with label/value. Used by SelectBox in EndpointTableFilterBar
	 * @param {string} p_label_attr The label attribute
	 * @param {string} p_value_attr The value attribute
	 * @param {boolean} p_add_blank_option_eh True to add a { "label": "", "value": "" } to the start of the list
	 * @returns {{}[]}
	 */
	static formattedStates(p_label_attr, p_value_attr, p_add_blank_option_eh)
	{
		let states = this.STATES.map(state => ({
			[p_label_attr]: state,
			[p_value_attr]: state
		}));

		if (p_add_blank_option_eh)
		{
			states.unshift({ "label": "", "value": "" });
		}
		return states;
	}
}